import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetOutOfStock = () => {
    const { data, isLoading ,refetch } = useQuery({
        queryKey: ['out-of-stock'],
        queryFn: async () => await apiClient.get('purchase-order/out-of-stock') as []
    });

    return {
        data: data || [],
        isLoading: isLoading,
        refetch: refetch
    };
};
